var DS = DS || (function () {
  var querySelector = document.querySelector.bind(document);
  var querySelectorAll = document.querySelectorAll.bind(document);

  return {
    $: querySelector,
    $$: querySelectorAll
  };
}());

